import { useMenu } from 'modules/common/hooks/useMenu';

import { AccountsMenu } from './components/AccountsMenu';
import { AccountMenuButton } from './components/AccountMenuButton';

export const AccountSelector = () => {
  const { anchorEl, handleClose, handleOpen, open } = useMenu();

  return (
    <>
      <AccountMenuButton isMenuOpen={open} onClick={handleOpen} />
      <AccountsMenu anchorEl={anchorEl} onClose={handleClose} open={open} />
    </>
  );
};
